<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="400">
      <v-card>
        <v-card-title class="text-h5 orange white--text">
          Expedientes del estudiante ISPI
        </v-card-title>

        <v-card-text>
            <p>Para ISPI puedes descargar los siguientes PDFs </p>
          <v-progress-linear indeterminate v-if="loading" />
          <p></p>
          <v-btn color="green" tile block @click="descargar_carta" :disabled="loading">carta compromiso</v-btn>
          <p></p>
          <v-btn color="green" tile block @click="descargar_beca" :disabled="loading">beneficio beca</v-btn>
          <p></p>
          <v-btn color="green" block @click="descargar_documens" :disabled="loading">entrega de documentos</v-btn> 
          <p></p>
          <v-btn color="green" block @click="descargar_expedientes" :disabled="loading">expediente del estudiante</v-btn> 
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" tile :disabled="loading" outlined @click="dialog = false">
            <v-icon small left> mdi-close </v-icon>
            Cerrar
          </v-btn> 
        </v-card-actions>
      </v-card>
    </v-dialog>

    <faltantes_compromiso ref="reffaltantes_compromiso" />
    <faltantes_beca ref="reffaltantes_beca" />
    <faltantes_docs ref="reffaltantes_docs" />
    <faltantes_expedientes ref="reffaltantes_expedientes" />
  </div>
</template>

<script>
import axios from 'axios'
import faltantes_compromiso from './faltantes_compromiso.vue';
import faltantes_beca from './faltantes_beca.vue';
import faltantes_docs from './faltantes_docs.vue';
import faltantes_expedientes from './faltantes_expedientes.vue';

  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        dato: {}
      };
    },
    components:{faltantes_compromiso,faltantes_beca,faltantes_docs,faltantes_expedientes},
    methods: {
      openmodal(datos) {
        this.dato = datos
        this.dialog = true;
        this.loading = false;
      },
      parseNombreProg(nom) {
        let n = (nom+'').replaceAll("Esam Cursos","")
        return n.trim() 
      },

      async descargar_carta() { 
        const plazo = await this.$refs.reffaltantes_compromiso.openmodal()
        if(!plazo) return
        
        const e = this.dato.estudiante
        if(!e.pri_apellido) e.pri_apellido = e.primer_apellido
        if(!e.seg_apellido) e.seg_apellido = e.segundo_apellido
        if(!e.institucion) e.institucion = {nombre:'?'}
        if(!e.est_civil) e.est_civil = e.estado_civil
        if(!e.fecha_nac) e.fecha_nac = e.fecha_nacimiento
        if(!e.num_doc) e.num_doc = e.numero_documento
        if(!e.seg_apellido) e.seg_apellido = ''
        const name = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`.trim()
        const doc = e.num_doc
        const prog = this.parseNombreProg(this.dato.programa.nombre_compuesto)
        const q = `mutation upi_exp_carta_compromiso{
        upi_exp_carta_compromiso(input:{
            estudiante:"${name}"
            documento:"${doc}"
            programa:"${prog}"
            dia_plazo:"${plazo}"
            pendientes:["Hola","mundo","jejejej","jojojo"]
        }) 
        }`
        const res = await this.sqlserver(q);
        if(res && res.data){
            const dt = res.data.upi_exp_carta_compromiso
            this.descargar(dt,name+'-carta_compromiso.pdf') 
        }
      },
      async descargar_beca() { 
        const beca = await this.$refs.reffaltantes_beca.openmodal()
        if(!beca) return

        const e = this.dato.estudiante
        if(!e.pri_apellido) e.pri_apellido = e.primer_apellido
        if(!e.seg_apellido) e.seg_apellido = e.segundo_apellido
        if(!e.institucion) e.institucion = {nombre:'?'}
        if(!e.est_civil) e.est_civil = e.estado_civil
        if(!e.fecha_nac) e.fecha_nac = e.fecha_nacimiento
        if(!e.num_doc) e.num_doc = e.numero_documento
        if(!e.seg_apellido) e.seg_apellido = ''
        const name = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`.trim()
        const doc = e.num_doc
        const prog = this.parseNombreProg(this.dato.programa.nombre_compuesto)
        const q = `mutation upi_exp_beneficio_beca{
        upi_exp_beneficio_beca(input:{
            estudiante:"${name}"
            documento:"${doc}"
            programa:"${prog}"
            turno: "${beca.turno}"
            fecha_otorgamiento:"${beca.fecha_otorgamiento}" 
            porcentaje_beca:"${beca.porcentaje_beca}"
        })
        }`
        const res = await this.sqlserver(q);
        if(res && res.data){
            const dt = res.data.upi_exp_beneficio_beca
            this.descargar(dt,name+'-beneficio_beca.pdf') 
        }
      },
      async descargar_documens() { 
        const docs = await this.$refs.reffaltantes_docs.openmodal()
        if(!docs) return

        const e = this.dato.estudiante
        if(!e.pri_apellido) e.pri_apellido = e.primer_apellido
        if(!e.seg_apellido) e.seg_apellido = e.segundo_apellido
        if(!e.institucion) e.institucion = {nombre:'?'}
        if(!e.est_civil) e.est_civil = e.estado_civil
        if(!e.fecha_nac) e.fecha_nac = e.fecha_nacimiento
        if(!e.num_doc) e.num_doc = e.numero_documento
        if(!e.seg_apellido) e.seg_apellido = ''
        const name = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`.trim()
        const doc = e.num_doc
        const prog = this.parseNombreProg(this.dato.programa.nombre_compuesto)
        const q = `mutation upi_exp_documentos{
        upi_exp_documentos(input:{
            estudiante:"${name}"
            documento:"${doc}"
            programa:"${prog}" 
            fecha:"${docs.fecha_presen}"  
            form_admision: ${docs.form_admision}
            cedula: ${docs.cedula}
            fotografias: ${docs.fotografias}
            diploma: ${docs.diploma}
            creditos: ${docs.creditos}
            cert_salud: ${docs.cert_salud}
        })
        }`
        const res = await this.sqlserver(q);
        if(res && res.data){
            const dt = res.data.upi_exp_documentos
            this.descargar(dt,name+'-entrega_docs.pdf') 
        }
      },
      async descargar_expedientes() {   
        const e = this.dato.estudiante 
        if(!e.pri_apellido) e.pri_apellido = e.primer_apellido
        if(!e.seg_apellido) e.seg_apellido = e.segundo_apellido
        if(!e.institucion) e.institucion = {nombre:'?'}
        if(!e.est_civil) e.est_civil = e.estado_civil
        if(!e.fecha_nac) e.fecha_nac = e.fecha_nacimiento
        if(!e.num_doc) e.num_doc = e.numero_documento 
        if(!e.seg_apellido) e.seg_apellido = ''

        const docs = await this.$refs.reffaltantes_expedientes.openmodal(this.dato)
        if(!docs) return  

        const name = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`.trim()
        const doc = e.num_doc 
        
        const prog = this.parseNombreProg(this.dato.programa.nombre_compuesto)
        const q = `mutation upi_expedientes{
          upi_expedientes(input:{
            carnet:"${doc}"
            pasaporte:"${docs.pasaporte}"
            nombre:"${e.nombres}"
            primer_apellido:"${e.pri_apellido}"
            segundo_apellido:"${e.seg_apellido}"
            fecha_ingreso:"${docs.fecha_ingreso}"
            carrera:"${prog}"
            telefono1:"${e.telefono1}"
            fecha_nac:"${e.fecha_nac}"
            nacionalidad:"${docs.nacionalidad}"
            estado_civil:"${e.est_civil}"
            sexo:"${e.sexo}"
            email:"${e.email}"
            provincia:"${docs.provincia}"
            canton:"${docs.canton}"
            distrito:"${docs.distrito}"
            direccion:"${e.domicilio}"
            institucion:"${e.institucion.nombre}"
            grado:"Diplomado"
          })
        }`
        const res = await this.sqlserver(q);
        if(res && res.data){
            const dt = res.data.upi_expedientes
            this.descargar(dt,name+'-expedientes.pdf') 
        }
      },

      async sqlserver(q) {
        this.loading = true
        const u = process.env.VUE_APP_CONTRATO;  

        const data = JSON.stringify({ query:q, variables: {} });
        const config = {};
        config.method = 'post';
        config.url = u;
        config.data = data;
        config.headers = { 'Content-Type': 'application/json' };
        const res = await axios.request(config).then(({ data }) => data).catch((e) => e);
        this.loading = false
        return res
      },
      descargar(base64, nombre) {
        const link = document.createElement('a');
        link.download = nombre;
        link.href = base64;
        link.click();
      }
    }, 
    
  };
</script>
